import { List } from 'immutable'
import { Fun } from 'widgets-for-react'
import { ComponentsBlockState } from './block/componentsBlock/componentsBlockState'

export type BlocksState = {
  blocks: List<Block>
}

export type Block =
  | ({
      kind: 'text'
    } & TextBlock)
  | ({
      kind: 'media'
    } & ImageBlock)
  | ({
      kind: 'quote'
    } & QuoteBlock)
  | ({
      kind: 'component-grid'
    } & ComponentsBlock)
  | ({
      kind: 'button'
    } & ButtonBlock)
  | ({
      kind: 'text_with_image'
    } & TextWithImageBlock)
  | ({
      kind: 'expandable_content'
    } & ExpandBlock)

export type TextBlock = {
  title: string
  text: string
}

export type ImageBlock = {
  items: {
    type: 'image' | 'video'
    displayoption: '' | 'content-width' | 'full-with'
    image: {
      url: string
      alt: string
    }
    tabletImage?: {
      url: string
      alt: string
    }
    mobileImage: {
      url: string
      alt: string
    }
    videoUrl: string
    caption: string
  }[]
  title: string
  intro: string
}

export type QuoteBlock = {
  text: string
  author: string
}

export type ComponentsBlock = {
  title: string
  components: {
    id: number
    lookupField: string
  }[]
  componentsBlocksState: ComponentsBlockState
}

export type ButtonBlock = {
  link: {
    title: string
    url: string
  }
}

export type TextWithImageBlock = {
  image_position: 'left' | 'right'
  image : {
    url: string
    alt: string
  }
  label: string
  title: string
  text: string
}

export type ExpandBlock = {
  title: string
  intro: string
  items: {
    title: string
    text: string
  }[]
}

export const initialBlocksState: BlocksState = {
  blocks: List(),
}

export const blocksStateUpdaters = {
  blockUpdater:
    (index: number) =>
    (updater: Fun<Block, Block & { reloadCollections?: boolean }>) =>
    (state: BlocksState): BlocksState & { reloadCollections?: boolean } => {
      const blockStateItem = state.blocks.get(index)
      if (blockStateItem) {
        const newBlockStateItemState = updater(blockStateItem)
        return {
          ...state,
          blocks: state.blocks.set(index, newBlockStateItemState),
          reloadCollections: newBlockStateItemState.reloadCollections,
        }
      } else return state
    },
  componentsBlockUpdater:
    (
      updater: Fun<
        ComponentsBlockState,
        ComponentsBlockState & { reloadCollections?: boolean }
      >
    ) =>
    (state: Block): Block & { reloadCollections?: boolean } => {
      if (state.kind === 'component-grid') {
        const newComponentsBlockState = updater(state.componentsBlocksState)

        return {
          ...state,
          componentsBlocksState: newComponentsBlockState,
          reloadCollections: newComponentsBlockState.reloadCollections,
        }
      } else return state
    }
}
